<template>
  <g>
    <path
      d="M9 12.0002C9 13.6602 10.34 15.0002 12 15.0002C13.66 15.0002 15 13.6602 15 12.0002C15 10.3402 13.66 9.00018 12 9.00018C10.34 9.00018 9 10.3402 9 12.0002Z"
    />
    <path
      d="M8 9.00018C8 8.45018 7.55 8.00018 7 8.00018H5.09C6.47 5.61018 9.05 4.00018 12 4.00018C15.49 4.00018 18.45 6.24018 19.54 9.36018C19.68 9.75018 20.07 10.0002 20.48 10.0002C21.16 10.0002 21.66 9.33018 21.44 8.69018C20.07 4.79018 16.36 2.00018 12 2.00018C8.73 2.00018 5.82 3.58018 4 6.01018V5.00018C4 4.45018 3.55 4.00018 3 4.00018C2.45 4.00018 2 4.45018 2 5.00018V9.00018C2 9.55018 2.45 10.0002 3 10.0002H7C7.55 10.0002 8 9.55018 8 9.00018Z"
    />
    <path
      d="M16 15.0002C16 15.5502 16.45 16.0002 17 16.0002H18.91C17.53 18.3902 14.95 20.0002 12 20.0002C8.51001 20.0002 5.55001 17.7602 4.46001 14.6402C4.32001 14.2502 3.93001 14.0002 3.52001 14.0002C2.84001 14.0002 2.34001 14.6702 2.56001 15.3102C3.93001 19.2102 7.64001 22.0002 12 22.0002C15.27 22.0002 18.18 20.4202 20 17.9902V19.0002C20 19.5502 20.45 20.0002 21 20.0002C21.55 20.0002 22 19.5502 22 19.0002V15.0002C22 14.4502 21.55 14.0002 21 14.0002H17C16.45 14.0002 16 14.4502 16 15.0002Z"
    />
  </g>
</template>
